<template>
    <BasePanel
        v-model="enabled"
        title="Descontos"
        hideEnable
        @closePanel="$emit('closePanel')">
        <div>
            <div class="flex justify-between items-center mt-2">
                <span class="flex-1" > Porcentagem </span>
                <currency-input
                    :disabled="lock"
                    :distraction-free="{ hideCurrencySymbol : false, hideNegligibleDecimalDigits: true, hideGroupingSymbol: true }"
                    value-as-integer
                    :precision="0"
                    :currency="{ suffix: '%' }"
                    class="vs-inputx vs-input--input normal hasValue danger flex-1 text-right"
                    v-model="percentageValue"
                    @keyup.enter="applyDiscount"
                    :valueRange="{ min: 0, max: 80 }"
                /> 
            </div>
            <div class="flex justify-between items-center mt-3">
                <span class="flex-1" > Quantia </span>
                {{ discountValue | currency }}
            </div>
            <vs-button
                class="w-full mt-5 py-2" type="border"
                :disabled="!percentageValue"
                @click="applyDiscount"
                >
                {{ lock ? 'Remover' : 'Aplicar' }}
            </vs-button>
            <!-- <vs-input label="Observações" placeholder="" class="mt-3 w-full"/> -->
            <vs-divider/>
            <div class="mt-1 flex justify-between">
                Total com desconto:
                <b>{{ baseValue - discountValue | currency }}</b>
            </div>
        </div>
    </BasePanel>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
    import BasePanel from './BasePanel';
    export default {
        components: {
            BasePanel,
        },
        props: {
            value: Boolean,
            totalValue: Number,
            leftToPay: Number,
            bill: Object
        },
        watch: {
            value (val) {
                if (val)
                    this.initialCheckup();
                else
                    this.setDiscountValue(0);
                this.$emit('input', !!this.discount.absolute.value);
            },
            discount:{
                handler (val) {
                    this.$emit('input', !!val.absolute.value);
                },
                deep: true
            }
        },
        data() {
            return {
                percentageValue: 0,
                baseValue: 0,
                lock: false
            }
        },
        computed: {
            enabled: {
                get () { return this.value },
                set (v) {
                    if (!v)
                        this.percentageValue = 0;
                    this.$emit('input', v); 
                }
            },
            discountValue () {
                return this.percentageValue > 80
                    ? this.baseValue * 0.8
                    : this.baseValue * (this.percentageValue / 100);
            },
            ...mapState('payment', ['discount'])
        },
        methods: {
            applyDiscount() {
                if (!this.enabled && this.discountValue > this.leftToPay) {
                    this.$warning({
                        zIndex : 9999999,
                        title: 'Desconto inválido',
                        content: 'O valor de desconto está acima do restante a pagar!',
                    });
                    return;
                }
                this.setDiscountValue(this.lock ? 0 : this.discountValue);
                this.lock = !this.lock;
                if (this.lock) {
                    this.$emit('closePanel');
                    this.$emit('input', true);
                } else {
                    this.percentageValue = 0;
                    this.$emit('input', false);
                }
            },
            initialCheckup () {
                this.percentageValue = (this.discount.absolute.value * 100 / this.baseValue);
                this.lock = !!this.percentageValue;
            },
            ...mapMutations('payment', ['setDiscountValue'])
        },
        mounted () {
            this.initialCheckup();
            this.baseValue = this.bill.value;
        },
    }
</script>

<style lang="scss" scoped>

</style>